import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ThemeSelector from './components/ThemeSelector';
import Quiz from './Quiz';
import Results from './Results';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-acid text-black">
        <audio id="bg-music" loop src="/8bit-music.mp3" preload="none" />
        <Header />
        <main className="flex-1 pt-28 md:pt-32 pb-8 max-w-3xl mx-auto w-full px-4">
          <Routes>
            <Route path="/" element={<ThemeSelector />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/results" element={<Results />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
